import { Injectable, signal } from '@angular/core';

/**
 * Serviço que controla a exibição da modal de timeout quando a sessão RHSSO expira.
 * O timeout é gerenciado pelo servidor RHSSO, não pelo cliente.
 */
@Injectable({ providedIn: 'root' })
export class IdleTimeoutService {
  // Signal para controlar se a modal de timeout está visível
  readonly showTimeoutModal = signal(false);
  
  /**
   * Exibe a modal de timeout quando o refresh token expira no servidor.
   */
  notifySessionExpired(): void {
    this.showTimeoutModal.set(true);
  }
  
  /**
   * Fecha a modal sem fazer nada (usado se necessário).
   */
  dismissModal(): void {
    this.showTimeoutModal.set(false);
  }
}
